import React, { useEffect } from "react";
import Swal from "sweetalert2";
import { domain } from "../../../Urls/Services/Api_urls";
import Dashboard from "../../Dasboard/Dashboard";
import { EmailComp } from "./EmailComp";

export const Emailfind = () => {
  useEffect(() => {
    window.sessionStorage.removeItem("idusercreationRes");
    window.sessionStorage.removeItem("emailRes");
    window.sessionStorage.removeItem("cedulaRes");
    window.sessionStorage.removeItem("phoneRes");
    window.sessionStorage.removeItem("namedasRes");
    window.sessionStorage.removeItem("last_nameRes");
  }, []);

  /**
   * The above function is an asynchronous function that handles form submission and makes a POST
   * request to a server to check if a username exists in the platform, and then performs certain
   * actions based on the response.
   */
  const handleSubmit = async ({ username }) => {
    try {
      const response = await fetch(domain + "/user/get/", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ username }),
      });

      if (response.ok) {
        // Autenticación exitosa
        let data_usuario = await response.json();
        window.sessionStorage.setItem("idusercreationRes", data_usuario.data["id"]);
        window.sessionStorage.setItem("emailRes", data_usuario.data["email"]);
        window.sessionStorage.setItem("cedulaRes", data_usuario.data["dni"]);
        window.sessionStorage.setItem("phoneRes", data_usuario.data["phone"]);
        window.sessionStorage.setItem("namedasRes", data_usuario.data["name"]);
        window.sessionStorage.setItem("last_nameRes", data_usuario.data["last_name"]);
        window.sessionStorage.setItem("Register", "Si");
        await Swal.fire({
          title: "Registrado",
          text: "Correo encontrado en la plataforma",
          icon: "success",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          window.location.href = "/Selectypebuy";
        });
      } else {
        // Error en la autenticación
        window.sessionStorage.removeItem("idusercreationRes");
        window.sessionStorage.removeItem("cedulaRes");
        window.sessionStorage.removeItem("phoneRes");
        window.sessionStorage.removeItem("namedasRes");
        window.sessionStorage.removeItem("last_nameRes");
        window.sessionStorage.setItem("emailRes", username);
        window.sessionStorage.setItem("Register", "No");
        await Swal.fire({
          title: "No Registrado",
          text: "Correo no encontrado en la plataforma",
          icon: "question",
          showConfirmButton: false,
          timer: 3000,
        }).then(() => {
          window.location.href = "/Selectypebuy";
        });
      }
    } catch (error) {
      console.error("Error al iniciar sesión:", error);
      await Swal.fire("Error", "Ocurrió un error al consultar email", "error");
    }
  };

  return (
    <>
      {" "}
      <Dashboard
        MInicio={""}
        Msolicitudes={""}
        Mservicios={""}
        Mcompra={""}
        Mcunyompra={"active"}
        Mempaquetar={""}
        Mcpotenciales={""}
        Madminportal={""}
        Mcampaña={""}
        Mtv={""}
      >
      <section style={{ margin: 1, padding: "1rem", display: "flex", justifyContent: "center", alignItems: "center" }}>
        <EmailComp onSubmit={handleSubmit} />
      </section>
      </Dashboard>
    </>
  );
};


// ## Summary
// The `Emailfind` function is responsible for handling the form submission and making a POST request to check if a username exists in the platform. It then performs certain actions based on the response.

// ## Example Usage
// ```javascript
// <Emailfind />
// ```

// ## Code Analysis
// ### Inputs
// - `username`: The username entered in the form.
// ___
// ### Flow
// 1. The function removes any existing user data from the session storage.
// 2. The function defines the `handleSubmit` function, which is called when the form is submitted.
// 3. Inside the `handleSubmit` function, a POST request is made to the server using the `fetch` function.
// 4. The request includes the `username` in the request body.
// 5. If the response is successful (status code 200), a success message is displayed using the `Swal.fire` function.
// 6. The user data is stored in the session storage.
// 7. If the response is not successful, an error message is displayed.
// 8. The function returns the JSX elements for the `Dashboard` component and the `EmailComp` component.
// ___
// ### Outputs
// - JSX elements for the `Dashboard` component and the `EmailComp` component.
// ___
